import { readableColor, rgba } from 'polished';
import styled from 'styled-components';
import { CloudOff } from '@/components/uielements/icon/cloud-off';
import { StyledPrimaryButton } from '@/components/uielements/primaryButton/styles';
import { COLORS, LAYOUT } from '@/constants/styles';
import { getFontStyles } from '@/redux/cmsConfig/utils';
import { safePolished } from '@/utils/safePolished';

/*
 * Banner (menu + checkout). Reuses the brand's `store_banner` theme tokens so the POS
 * message matches the store's existing banner styling, per the ticket's "generalise the
 * existing store-page banner" direction and the request to use brand colors.
 */
export const Banner = styled.div(({ theme }) => ({
  backgroundColor: theme.store_banner.background_color ?? 'transparent',
  borderBottom: `1px solid ${theme.store_banner.border_color ?? 'transparent'}`,
  padding: '16px 20px',
}));

export const BannerContent = styled.div(({ theme }) => ({
  display: 'flex',
  gap: '10px',
  margin: '0 auto',
  maxWidth: '900px',
  alignItems: 'center',
  justifyContent: 'center',
  ...getFontStyles(theme.store_banner.font, {
    color: (value) => value ?? safePolished(readableColor)(theme.store_banner.background_color),
  }),
  svg: { flexShrink: 0 },
}));

export const CallLink = styled.a({
  color: 'inherit',
  fontWeight: 700,
  textDecoration: 'underline',
  whiteSpace: 'nowrap',
});

/* Modal — mirrors the existing unavailability modals' warning-circle treatment. */
export const ModalWrapper = styled.div({
  width: '100%',
  padding: `${LAYOUT.GUTTER}px`,
  textAlign: 'center',
});

export const IconCircle = styled.div({
  width: '80px',
  height: '80px',
  margin: '0 auto 24px',
  borderRadius: '100%',
  backgroundColor: rgba(COLORS.PRIMARY_WARNING, 0.13),
  border: `1px solid ${COLORS.PRIMARY_WARNING}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const ModalIcon = styled(CloudOff)({
  width: '32px',
  height: '32px',
  color: COLORS.PRIMARY_WARNING,
});

export const ModalTitleText = styled.h2({
  fontSize: '24px',
  fontWeight: 700,
  lineHeight: '32px',
  margin: '0 0 8px',
});

export const ModalBodyText = styled.p({
  fontSize: '16px',
  lineHeight: '24px',
  margin: 0,
});

export const ModalCloseButton = styled(StyledPrimaryButton)({
  width: '100%',
  marginTop: '24px',
});

/* Checkout helper text sitting above the disabled Place Order button (mirrors PreSubmitMessage). */
export const CheckoutHelperText = styled.p({
  fontStyle: 'italic',
  margin: 0,
  padding: '8px 16px 0',
  textAlign: 'center',
});
